import React from "react";
import { useQuery, gql } from "@apollo/client";
import { useParams } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from "@material-ui/core";

import { KeyValueArray } from "./KeyValueArray";

const GET_COLLEGE_INFO = gql`
  query Query($getCollegeInfoCollegeId: String) {
    getCollegeInfo(collegeId: $getCollegeInfoCollegeId)
  }
`;

export function Admission() {
  const { collegeId } = useParams();

  const { loading, error, data } = useQuery(GET_COLLEGE_INFO, {
    fetchPolicy: "cache-first",
    variables: {
      getCollegeInfoCollegeId: collegeId,
    },
  });

  if (loading) {
    return (
      <Box>
        <CircularProgress style={{ color: "#3699FF" }} />
      </Box>
    );
  }

  let collegeDetails = !error ? JSON.parse(data.getCollegeInfo) : {};

  const mainInfo = [
    { key: "admissionWebsite", value: collegeDetails.admissionsWebsite },
    {
      key: "acceptanceRate",
      value: collegeDetails.acceptanceRate
        ? (collegeDetails.acceptanceRate * 100).toFixed(2) + "%"
        : "--",
    },
    {
      key: "secondarySchoolRecordRequirement",
      value: collegeDetails.secondarySchoolRecordRequirement,
    },
    { key: "totalApplicants", value: collegeDetails.totalApplicants },
    { key: "totalEnrolled", value: collegeDetails.totalEnrolled },
    { key: "hsRankRequirement", value: collegeDetails.hsRankRequirement },
  ];

  console.log(mainInfo);

  const satInfo = Object.keys(collegeDetails)
    .filter((k) => k.startsWith("sat"))
    .map((key) => {
      return { key, value: collegeDetails[key] };
    });

  const actInfo = Object.keys(collegeDetails)
    .filter((k) => k.startsWith("act"))
    .map((key) => {
      return { key, value: collegeDetails[key] };
    });

  console.log(actInfo);

  return (
    <>
      <Card className="mb-5">
        <CardContent>
          <Typography variant="h4" className="text-center" color="primary">
            {collegeDetails.name + " Admissions"}
          </Typography>
        </CardContent>
      </Card>

      <Card className="mb-5">
        <CardContent>
          <Grid container spacing={8}>
            <Grid item sm={6}>
              <KeyValueArray
                data={mainInfo.slice(0, Math.floor(mainInfo.length / 2))}
              />
            </Grid>
            <Grid item sm={6}>
              <KeyValueArray
                data={mainInfo.slice(Math.floor(mainInfo.length / 2))}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Grid container spacing={8}>
            <Grid item sm={6}>
              <Typography variant="h6" className="text-center" color="primary">
                SAT
              </Typography>
              <KeyValueArray data={satInfo} />
            </Grid>
            <Grid item sm={6}>
              <Typography variant="h6" className="text-center" color="primary">
                ACT
              </Typography>
              <KeyValueArray data={actInfo} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
